import React, { useState } from 'react';
import { ChevronRight, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { useProfile } from '../../contexts/ProfileContext';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

interface DailyOverviewProps {
  userName: string;
}

export function DailyOverview({ userName }: DailyOverviewProps) {
  const { user } = useAuthContext();
  const { profile } = useProfile();
  const displayName = user?.user_metadata?.name || profile.name || userName;
  const today = new Date();
  const currentWeek = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(today);
    date.setDate(today.getDate() - today.getDay() + i);
    return date;
  });

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const formatDate = () => {
    return new Date().toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="space-y-8">
      <div className="flex flex-col space-y-4">
        <div className="space-y-1">
          <h1 className="text-3xl font-bold text-white">
            {getGreeting()},
          </h1>
          <h2 className="text-3xl font-medium text-white">
            <Link 
              to="/profile" 
              className="inline-flex items-center gap-1 text-[#bbdde5] hover:opacity-90 transition-opacity font-medium"
            >
              {displayName}
              <ChevronRight className="w-4 h-4" />
            </Link>
          </h2>
        </div>
        
        <div className="flex items-center space-x-4 text-lg">
          {currentWeek.map((date, index) => (
            <div key={index} className="flex flex-col items-center">
              <span className="text-gray-400">{DAYS[date.getDay()]}</span>
              <span className={`w-10 h-10 flex items-center justify-center rounded-full mt-2 
                ${date.getDate() === today.getDate() ? 'bg-[#bbdde5] text-black' : 'hover:bg-black/20'}`}>
                {date.getDate()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}